class FreightInsurance extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input');

    // 非美国用户且标记了 data-us 时隐藏组件
    if (window.Shopify && window.Shopify.country !== 'US' && this.dataset.us) {
      this.classList.add('hidden');
      this.innerHTML = '';
      document.querySelector('cart-drawer')?.setAttribute('data-freight-insurance', 'false');
      return;
    }

    document.querySelector('cart-drawer')?.setAttribute('data-freight-insurance', 'true');

    // reeview 组件为空时去掉 margin
    if (this.dataset.type === 'product') {
      window.addEventListener('load', () => {
        const reeview = document.querySelector('.reeview-app-widget');
        if (reeview && reeview.innerHTML === '') {
          this.style.margin = '0';
        }
      }, { once: true });
    }

    // 监听 checkbox 变化
    if (this.input) {
      this.input.addEventListener('change', (e) => {
        this.setAttribute('data-checked', e.target.checked);
        if (
          e.target.checked &&
          (this.closest('.cart-drawer__footer') || this.closest('.cart__footer'))
        ) {
          setTimeout(() => { this.addFreightInsurance(); }, 200);
        }
      });
    }

    // 购物车变化时同步 data-added 状态
    this._onCartChange = () => { this.syncAddedState(); };
    document.addEventListener('on:cart:change', this._onCartChange);
  }

  disconnectedCallback() {
    if (this._onCartChange) {
      document.removeEventListener('on:cart:change', this._onCartChange);
    }
  }

  syncAddedState() {
    const fiId = this.dataset.productId;
    if (!fiId) return;
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const inCart = cart.items?.some(item => String(item.id) === String(fiId)) ?? false;
        this.setAttribute('data-added', inCart ? 'true' : 'false');
      })
      .catch(() => {});
  }

  async addFreightInsurance() {
    const productId = this.dataset.productId;

    const sectionsToUpdate = ['page-header', 'cart-drawer', 'main-cart', 'main-product']
      .map(sel => document.querySelector(sel))
      .filter(Boolean);

    const sectionIds = sectionsToUpdate
      .map(el => el.dataset.sectionId)
      .filter(Boolean);

    const body = new FormData();
    body.append('id', productId);
    body.append('quantity', 1);
    body.append('sections', sectionIds.join(','));
    body.append('sections_url', window.location.pathname);

    try {
      const response = await fetch(theme.routes.cartAdd, {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body
      });

      console.log('response', response);
      const data = await response.json();

      let error = typeof data.description === 'string' ? data.description : data.message;
      if (data.errors && typeof data.errors === 'object') {
        error = Object.entries(data.errors).map(item => item[1].join(', '));
      }
      if (data.status) this.setErrorMsgState(error);
      if (!response.ok) throw new Error(response.status);

      // 所有 freight-insurance 元素标记为已添加
      document.querySelectorAll('freight-insurance').forEach(item => {
        setTimeout(() => {
          item.setAttribute('data-added', 'true');
          const inp = item.querySelector('input');
          if (inp) inp.checked = false;
        });
      });

      if (document.querySelector('.template-cart')) {
        document.querySelector('cart-form')?.refresh?.();
      } else {
        if (data.sections) {
          sectionsToUpdate.forEach(el => {
            const html = data.sections[el.dataset.sectionId];
            if (html) el.updateFromCartChange?.(html);
          });
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        }
      }
    } catch (error) {
      console.log(error);
      this.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
    }
  }
}

customElements.define('freight-insurance', FreightInsurance);